import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

import { reactive, ref, computed } from 'vue'
import { findByPage } from '@/api/yuntuSales/zhiQuLog'


const __default__ = { name: 'DcCosLbuZhiQuLog' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tableRef = ref()
const queryForm = reactive({
  requestSource: undefined,
  startTime: '',
  endTime: '',
  requestContent: '',
  responseContent: ''
})

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await findByPage(params)
  callBack(res)
}

const requestSourceEnum = [
  {
    value: 'register',
    label: '官网注册'
  },
  {
    value: 'qrcode',
    label: '市场活码'
  },
  {
    value: 'icss',
    label: '工单系统'
  },
  {
    value: 'consultation',
    label: '官网咨询'
  },
  {
    value: 'lcos',
    label: 'LCOS'
  },
  {
    value: 'zhi_qu',
    label: '致趣百川'
  }
]

const requestTypeEnum = [
  {
    value: 0,
    label: '推送致趣百川'
  },
  {
    value: 1,
    label: '致趣百川投放'
  },
  {
    value: 2,
    label: '同步客户信息'
  },
  {
    value: 3,
    label: '同步流出公海线索信息'
  },
  {
    value: 4,
    label: '致趣百川二次投放'
  }
]

const columns = computed(() => [
  {
    title: '来源系统',
    dataIndex: 'requestSource',
    dicData: requestSourceEnum
  },
  {
    title: '创建时间',
    dataIndex: 'createTime'
  },
  {
    title: '类型',
    dataIndex: 'requestType',
    dicData: requestTypeEnum
  },
  {
    title: '请求参数',
    dataIndex: 'requestContent'
  },
  {
    title: '结果',
    dataIndex: 'responseContent'
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm,
            "onUpdate:search": _cache[6] || (_cache[6] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "requestSource",
                    label: "来源系统"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.requestSource,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.requestSource) = $event)),
                        placeholder: "请选择",
                        "allow-clear": "",
                        options: requestSourceEnum
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "创建时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        style: {"width":"100%"},
                        startTime: queryForm.startTime,
                        "onUpdate:startTime": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.startTime) = $event)),
                        endTime: queryForm.endTime,
                        "onUpdate:endTime": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.endTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "requestContent",
                    label: "请求参数"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.requestContent,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.requestContent) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "responseContent",
                    label: "结果"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.responseContent,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.responseContent) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "requestType",
                    label: "类型"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.requestType,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.requestType) = $event)),
                        placeholder: "请选择",
                        "allow-clear": "",
                        options: requestTypeEnum
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _createVNode(_component_ExportButton, {
                appId: "cos_lbu",
                taskType: "335",
                search: queryForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search"])
            ]),
            bodyCell: _withCtx(({ column }) => [
              (column.dataIndex === 'type')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" 推送智趣百川 ")
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})